export default __webpack_public_path__ + "static/photobooth-824d6f6e10c8fdac04bc8fdeb62641a1.jpg";